import React, { useEffect, useState } from "react";

const SHOW_IF_MORE_THAN = 80; // px of page still below the screen before the pill appears

// A pill at the bottom of the screen that shows while there's more page to scroll to.
const ScrollHint = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const check = () => {
      const left = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      setShow(left > SHOW_IF_MORE_THAN);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    // the page height changes when a new page loads or content resizes
    const observer = new ResizeObserver(check);
    observer.observe(document.body);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
      observer.disconnect();
    };
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" })}
      aria-label="Scroll down"
      tabIndex={show ? 0 : -1}
      className={`fixed bottom-6 left-1/2 z-[2500] flex -translate-x-1/2 items-center gap-2 rounded-full bg-emerald-100/80 px-4 py-2 text-sm font-bold shadow-lg backdrop-blur-md transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      Scroll
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="h-4 w-4 motion-safe:animate-bounce"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
  );
};

export default ScrollHint;
